import { Helmet } from "react-helmet-async";
import { ReactNode } from "react";

interface SEOProps {
    title: string;
    description: string;
    image?: string;
    url?: string;
    type?: string;
    keywords?: string;
    children?: ReactNode;
}

export const SEO = ({
    title,
    description,
    image,
    url,
    type = "website",
    keywords,
    children
}: SEOProps) => {
    const siteTitle = "IndieKeys";
    const siteName = "IndieKeys - Indie Game Key Distribution Platform";
    const fullTitle = title.includes(siteTitle) ? title : `${title} | ${siteTitle}`;
    const currentUrl = url || (typeof window !== 'undefined' ? window.location.href : 'https://indie-keys.com');
    const domain = 'https://indie-keys.com';
    const imageUrl = image ? (image.startsWith('http') ? image : `${domain}${image}`) : '';

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            {keywords && <meta name="keywords" content={keywords} />}

            {/* Open Graph - Complete */}
            <meta property="og:site_name" content={siteName} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:type" content={type} />
            <meta property="og:url" content={currentUrl} />
            {imageUrl && <meta property="og:image" content={imageUrl} />}
            {imageUrl && <meta property="og:image:width" content="1200" />}
            {imageUrl && <meta property="og:image:height" content="630" />}
            {imageUrl && <meta property="og:image:alt" content={fullTitle} />}
            <meta property="og:locale" content="en_US" />

            {/* Twitter Cards - Complete */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            {imageUrl && <meta name="twitter:image" content={imageUrl} />}
            {imageUrl && <meta name="twitter:image:alt" content={fullTitle} />}

            {/* Additional SEO */}
            <meta name="robots" content="index, follow" />
            <meta name="author" content="IndieKeys" />
            <link rel="canonical" href={currentUrl} />

            {children}
        </Helmet>
    );
};
